import { ApolloError } from "@apollo/client";
import React from "react";
import { useRouter } from "next/router";

import OrgUsersEdit from "src/components/account/forms/OrgUsersEdit";

import { useUser } from "src/hooks/useUser";
import { Org, ProjectCardFieldsFragment, User } from "src/lib/graphql/types";
import ProfileProjectCard from "./ProfileProjectCard";
import NoProfileProjects from "./NoProfileProjects";
import { TabOption } from "./ProfileData";
import ProfileMainBodyLoader from "./ProfileMainBodyLoader";

type ProfileDataResolverProps = {
  loading: boolean;
  results: ProjectCardFieldsFragment[] | undefined;
  entity: User | Org;
  tab: TabOption;
  error: ApolloError | undefined;
};

export function ProfileDataResolver({
  loading,
  results,
  entity,
  tab,
  error,
}: ProfileDataResolverProps) {
  const [user, _setUser, userLoading] = useUser();

  const router = useRouter();

  const { projectSlug } = router.query as { projectSlug: string[] | undefined };

  if (loading || userLoading) {
    return <ProfileMainBodyLoader projectSlug={projectSlug} />;
  } else {
    if (tab.value === "Members") {
      const org = entity as Org;

      const foundOrg = user?.memberOf?.find(
        (membership) => membership.org?.shortname === org.shortname
      );

      const orgAdmin = foundOrg?.role?.name === "Admin";

      if (foundOrg) {
        return (
          <OrgUsersEdit
            org={org}
            orgAdmin={orgAdmin}
            orgLoading={loading}
            user={user!}
          />
        );
      } else {
        return <ProfileMainBodyLoader projectSlug={projectSlug} />;
      }
    }
    if ((results && !results.length) ?? error) {
      return (
        <NoProfileProjects
          entity={entity}
          type={tab}
        />
      );
    } else {
      return (
        <div className="profile-project-cards">
          {(results ?? []).map((project) => (
            <ProfileProjectCard
              project={project}
              key={project.pathWithNamespace}
            />
          ))}
        </div>
      );
    }
  }
}
